import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Refund } from './refund.entity';
import { RefundStatus } from './refund.status.enum';

export class CreateRefundDto extends Omit(Refund, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: RefundStatus;
}
